import React from 'react';
import './../App.css';

export default function Header(){

    const skills = [
        '5+ years of experience in Front-end & UI Development ',
        'Expertise in CSS pre-processors (SCSS, SASS) and utility-first frameworks like TailwindCSS',
        'Experience in mobile-first and responsive web design methodologies',
        'Solid understanding of BEM methodologies for scalable CSS architecture',
        'Experience with Contentful and CMS platforms for structured, scalable content management',
        'Strong workflow automation skills with Gulp.js and Webpack',
        'Developed smooth, high-performance scroll and interaction animations for engaging user experiences',
        'Expert in Webflow - CMS, dynamic content, custom code, and SEO optimization',
        'Strong knowledge of JavaScript, TypeScript, and modern front-end frameworks',
        'Knowledge in React.js, Next.js, and Svelte.js for building dynamic web applications',
        'Knowledge in Prisma and MongoDB and SQL',
        'Strong UI/UX design skills, proficient in Figma, Adobe XD, and Sketch',
        'Worked with Agile and Scrum methodologies, ensuring efficient collaboration and delivery',
        'Proficient in version control technologies (Git, GitHub, GitLab, Bitbucket)',
        'Expertise in component-based architecture - Developing scalable and maintainable UI systems',
        'Experience with .NET environments - Working with CSHTML, Razor, and backend integration',
        'PHP templating experience – Implementing and integrating UI within PHP-based back-end systems',
      
    ];

    return(
        <div>
            <div className="summaryTxtHeader"> 
                <h1>About Me</h1> 
                <h3>Summary Information</h3> 
            </div>
            <div>
                <p className='aboutMeTxt'>
                I'm a Senior Front-End Developer | UI Developer | Webflow Developer with 5+ years of experience in building high-performance, scalable, and visually appealing websites. I specialize in developing responsive, cross-browser, and maintainable user interfaces using modern front-end technologies.
                I have strong expertise in UI frameworks, animations, and performance optimization. My experience spans working with companies across the Middle East, Europe, and North America, delivering pixel-perfect designs, complex animations, and scalable UI architectures. I excel at bridging the gap between design and development, ensuring seamless user experiences while optimizing for speed and efficiency.
                </p>
                    <ul className='summaryInfoList'> 
                    {
                        skills.map((item,index) => {
                            return <li key={index}>
                                <span>⦿</span>
                                <p>{item}</p>
                                </li>
                        })
                    }
                </ul>
                </div>
        
        </div>
    )
}